import { ICellRendererParams } from 'ag-grid-community';
import { TokenBalance } from '../../types';

export const TokenCellRenderer = (
  params: ICellRendererParams<TokenBalance>,
) => {
  const token = params.data;
  if (!token) return null;

  // Truncate name if it's too long, similar to "Ethereum Nam..."
  const truncateName = (name: string, maxLength: number = 12) => {
    if (name.length <= maxLength) return name;
    return name.substring(0, maxLength) + '...';
  };

  const displayText = `${truncateName(token.name)} (${token.symbol})`;

  return (
    <div className="flex items-center gap-3">
      {token.logo ? (
        <img
          src={token.logo}
          alt={token.name}
          className="h-8 w-8 rounded-full"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      ) : (
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-muted text-sm font-medium">
          {token.symbol.charAt(0)}
        </div>
      )}
      <span
        className="font-medium text-foreground"
        title={`${token.name} (${token.symbol})`}
      >
        {displayText}
      </span>
    </div>
  );
};
